import { render } from "./VehicleOrder.vue?vue&type=template&id=44434df4&scoped=true&bindings={}"
import script from "./VehicleOrder.vue?vue&type=script&lang=ts"
export * from "./VehicleOrder.vue?vue&type=script&lang=ts"

import "./VehicleOrder.vue?vue&type=style&index=0&id=44434df4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44434df4"

export default script